/**
 * Created by mady on 08-06-2017.
 */
(function ($, DGS) {
  DGS.useCustomSelect();
})(jQuery, window.DGS);